module.exports = __webpack_public_path__ + "img/jqr_yt.80b73ab6.png";